import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { ApiSearchQuery } from '@/lib/api/api-type-helper';
import type { ProductPermission, SortableColumns } from './-types';
type QUERY = ApiSearchQuery<'/v2/settings/product-permissions', 'get'>;
type CATEGORY = Exclude<QUERY, undefined>['category'];
type CATEGORY_KEY = Exclude<CATEGORY, undefined>;
export const TabKey = {
  ALL: 'ALL'
  // DEPRECATED: "DEPRECATED",
} as const satisfies Record<CATEGORY_KEY, string>;
export type TabKey = EnumUnion<typeof TabKey>;
export const PRODUCT_PERMISSION_COLUMNS = {
  PRODUCT_PERMISSION_NAME: 'productPermissionName',
  TOTAL_ACCESSIBLE_PRODUCTS: 'totalAccessibleProducts',
  IT_FORCE: 'itForce',
  HR_FORCE: 'hrForce',
  GA_FORCE: 'gaForce',
  LI_FORCE: 'liForce',
  BUSINESS_CENTRAL: 'businessCentral',
  MARKETPLACE: 'marketplace',
  OPERATION_EVENT: 'operationEvent',
  SETTINGS: 'settings',
  REFERENCED_ROLES: 'referencedRoles'
} as const satisfies Record<string, keyof ProductPermission>;
export type ProductPermissionColumn = EnumUnion<typeof PRODUCT_PERMISSION_COLUMNS>;
export type OrderBy = Exclude<QUERY['orderBy'], undefined>;
export const SortColumns = ['PRODUCT_PERMISSION_NAME'] as const satisfies OrderBy[];
export const COLUMNS_TO_SORT_COLUMNS = {
  productPermissionName: 'PRODUCT_PERMISSION_NAME'
} as const satisfies Record<SortableColumns, OrderBy>;
export const SORT_COLUMNS_TO_COLUMNS = {
  PRODUCT_PERMISSION_NAME: 'productPermissionName'
} as const satisfies Record<OrderBy, SortableColumns>;